export const PROGRAMACAO_DIARIA_DIA_FIND_BY_ID = 'PROGRAMACAO_DIARIA_DIA_FIND_BY_ID';
export const PROGRAMACAO_DIARIA_DIA_FIND_BY_ID_SUCCESS = 'PROGRAMACAO_DIARIA_DIA_FIND_BY_ID_SUCCESS';

export const SAVE_PROGRAMACAO_DIARIA_DIA = 'SAVE_PROGRAMACAO_DIARIA_DIA';
export const SAVE_PROGRAMACAO_DIARIA_DIA_SUCCESS = 'SAVE_PROGRAMACAO_DIARIA_DIA_SUCCESS';

export const UPDATE_PROGRAMACAO_DIARIA_DIA = 'UPDATE_PROGRAMACAO_DIARIA_DIA';
export const UPDATE_PROGRAMACAO_DIARIA_DIA_SUCCESS = 'UPDATE_PROGRAMACAO_DIARIA_DIA_SUCCESS';

export const PROGRAMACAO_DIARIA_DIA_EXPORT = 'PROGRAMACAO_DIARIA_DIA_EXPORT';

export const CLEAR_PROGRAMACAO_DIARIA_DIA = 'CLEAR_PROGRAMACAO_DIARIA_DIA';
